export function toCSSLength(val: string | number, unit?: string): string;
export function toCSSLength(
  val?: string | number,
  unit?: string
): string | undefined;
export function toCSSLength(val?: string | number, unit = "px") {
  return typeof val === "number" ? `${val}${unit}` : val;
}
